import { Box, Flex, Heading, Image, Text, Link, VStack } from "@chakra-ui/react"; 
import HalfScreenSection from "./HalfScreenSection";

export default function DownloadApp({heading = "Download the app On Launch date (March 20, 2026)"}) {
     return ( 
         <HalfScreenSection
            backgroundColor="gray.800"
            isDarkBackground
            
            spacing={8}
            id="download-section"
         >
            <Box  p={{ base: 24, md: 28}} borderRadius="12px" maxW="900px" mx="auto" 
            justifyContent="center" alignItems="center" textAlign="center" > 
                <Heading fontSize="1.6rem" mb={6} > {heading} </Heading>
                
                <Flex direction="column" align="center" gap={6} > 
                  
                   
                    {/* Store Buttons */} 
                    <Flex direction="row" align="center" spacing={5} gap={6}> {/* Google Play */} 
                        <Link href="#" _hover={{ transform: "translateY(-2px)" }} 
                            transition="0.15s ease" 
                            alignItems="center" w="fit-content" 
                        > 
                            <Image src="/GetItOnGooglePlay.svg" alt="Google Play" width="198px" height="70px" />
                        
                        
                        </Link> {/* App Store */} 
                        <Link href="#" _hover={{ transform: "translateY(-2px)"}} 
                            transition="0.15s ease" alignItems="center"  w="fit-content" 
                        > 
                            <Image src="/AppStore.svg" alt="App Store" width="200px" height="60px" />
                            
                        </Link> 
                    </Flex>
                       
                        <Text fontSize="0.95rem" mb={1}> 
                            Scan the code with your phone to Download
                        </Text> 

                         {/* QR Code */} 
                          {/* QR Code */}
                    <Image 
                        src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://swiftchang.com/download" 
                        alt="QR code" 
                        boxSize="150px" 
                        borderRadius="8px" 
                        bg="white" 
                        objectFit="cover" 
                        boxShadow="0 4px 12px rgba(0,0,0,0.06)"
                        p={2}
                    />

                </Flex> 
            </Box> 
        </HalfScreenSection>); 
    }